var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap",attrs:{"id":_vm.tplSkinId}},[(_vm.tplSkinId != 'tpl-basic')?_c('MysohoSpecialHeader'):_vm._e(),_c('MysohoHeader'),_c('MysohoContent'),_c('MysohoFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }